import React, { Component } from 'react'
import { Segment, Form } from 'semantic-ui-react'

const REPORT_TYPE_OPTIONS = [
    { key: 'audit', text: 'Audit', value: 'Audit' },
    { key: 'sales_audit', text: 'Sales Audit', value: 'Sales Audit' },
    { key: 'accountant_report', text: 'Accountant Report', value: 'Accountant Report' },
    { key: 'tax', text: 'Tax', value: 'Tax' },
    { key: 'fs', text: 'FS', value: 'FS' }
]

class ReportCaseCreateCoreSection extends Component {
    buildUserOptions() {
        const users = Array.isArray(this.props.users) ? this.props.users : []
        return [{ key: 'empty', text: '-', value: '' }].concat(
            users.map(u => ({
                key: u._id,
                text: u.name || u.email,
                value: u._id
            }))
        )
    }

    render() {
        const { values, onChange, onSubmit } = this.props

        return (
            <Segment basic style={{ padding: 0, marginTop: 10 }}>
                <Form onSubmit={onSubmit}>
                    <Form.Input
                        required
                        label='Company Name'
                        placeholder='e.g. ABC Pte Ltd'
                        value={values.companyName}
                        onChange={(e) => onChange('companyName', e.target.value)}
                    />

                    <Form.Group widths='equal'>
                        <Form.Input
                            type='date'
                            label='Email Received On'
                            value={values.emailReceivedOn}
                            onChange={(e) => onChange('emailReceivedOn', e.target.value)}
                        />

                        <Form.Select
                            search
                            label='Person In Charge (PIC)'
                            placeholder='Select user'
                            options={this.buildUserOptions()}
                            value={values.personInCharge || ''}
                            onChange={(e, { value }) => onChange('personInCharge', value)}
                        />
                    </Form.Group>

                    <Form.Group widths='equal'>
                        <Form.Dropdown
                            fluid
                            multiple
                            selection
                            search
                            label='Report Types'
                            placeholder='Select report types'
                            options={REPORT_TYPE_OPTIONS}
                            value={values.reportTypes || []}
                            onChange={(e, { value }) => onChange('reportTypes', value)}
                        />

                        <Form.Input
                            label='Custom Report Type'
                            placeholder='e.g. Special Review, Agreed-Upon Procedures...'
                            value={values.customReportType || ''}
                            onChange={(e) => onChange('customReportType', e.target.value)}
                        />

                        <Form.Input
                            label='FYE / Period'
                            placeholder='e.g. 2025/12 or 31-12-2025'
                            value={values.fye}
                            onChange={(e) => onChange('fye', e.target.value)}
                        />
                    </Form.Group>

                    <Form.Checkbox
                        label='XBRL Service'
                        checked={!!values.xbrlService}
                        onChange={(e, { checked }) => onChange('xbrlService', !!checked)}
                    />

                    <Form.TextArea
                        label='Printing / Processing Instructions'
                        placeholder='Anything the team should know…'
                        value={values.instructions}
                        onChange={(e) => onChange('instructions', e.target.value)}
                    />

                    <Form.Group widths='equal'>
                        <Form.Input
                            type='date'
                            label='Due Date'
                            value={values.dueDate}
                            onChange={(e) => onChange('dueDate', e.target.value)}
                        />

                        <Form.Input
                            type='date'
                            label='Next Follow-up Date'
                            value={values.nextFollowUpDate}
                            onChange={(e) => onChange('nextFollowUpDate', e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group widths='equal'>
                        <Form.Input
                            label='Outstanding Amount'
                            placeholder='e.g. 1200'
                            value={values.totalOutstanding}
                            onChange={(e) => onChange('totalOutstanding', e.target.value)}
                        />

                        <Form.Input
                            label='Payment Remark'
                            placeholder='e.g. waiting transfer receipt'
                            value={values.paymentRemark}
                            onChange={(e) => onChange('paymentRemark', e.target.value)}
                        />
                    </Form.Group>

                    {/* no buttons here on purpose */}
                </Form>
            </Segment>
        )
    }
}

export default ReportCaseCreateCoreSection